import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

const { FiX, FiCheck, FiCalendar, FiClock, FiVideo, FiShield } = FiIcons;

const JoinWorkshopModal = ({ isOpen, onClose, workshop }) => {
  const [isJoined, setIsJoined] = useState(false);
  const [isJoining, setIsJoining] = useState(false);

  if (!isOpen || !workshop) return null;

  const handleJoin = () => {
    setIsJoining(true);
    setTimeout(() => {
      setIsJoining(false);
      setIsJoined(true);
      setTimeout(() => {
        setIsJoined(false);
        onClose();
      }, 2500);
    }, 1200);
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-start sm:items-center justify-center p-4 bg-accent-navy/60 backdrop-blur-md overflow-y-auto">
      <motion.div 
        initial={{ opacity: 0, scale: 0.95, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        className="bg-white rounded-[40px] shadow-2xl w-full max-w-xl overflow-hidden border border-brand-dark my-4 sm:my-8"
      >
        <div className="p-8 md:p-12 relative">
          <button onClick={onClose} 
            className="absolute top-8 right-8 p-2 hover:bg-brand-light rounded-full text-text-muted transition-colors">
            <SafeIcon icon={FiX} className="w-6 h-6" />
          </button>

          <AnimatePresence mode="wait">
            {!isJoined ? (
              <motion.div key="details" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
                <div className="mb-10 text-center md:text-left">
                  <span className="bg-accent-gold/10 text-accent-gold px-4 py-1.5 rounded-full text-[10px] font-black uppercase tracking-widest border border-accent-gold/20 mb-6 inline-block">
                    Confirm Registration
                  </span>
                  <h3 className="text-3xl font-serif text-accent-navy mb-4">{workshop.title}</h3>
                  <p className="text-text-muted font-light leading-relaxed">{workshop.description}</p>
                </div>

                <div className="bg-brand-light p-8 rounded-3xl border border-brand-dark space-y-6 mb-10">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-white rounded-2xl flex items-center justify-center text-accent-gold shadow-sm border border-brand-dark/20">
                      <SafeIcon icon={FiCalendar} className="w-6 h-6" />
                    </div>
                    <div>
                      <p className="text-[10px] font-black uppercase text-text-muted tracking-widest">Date</p>
                      <p className="text-sm font-bold text-accent-navy">{new Date(workshop.date).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-white rounded-2xl flex items-center justify-center text-accent-gold shadow-sm border border-brand-dark/20">
                      <SafeIcon icon={FiClock} className="w-6 h-6" />
                    </div>
                    <div>
                      <p className="text-[10px] font-black uppercase text-text-muted tracking-widest">Time</p>
                      <p className="text-sm font-bold text-accent-navy">{workshop.time} ({workshop.duration})</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-white rounded-2xl flex items-center justify-center text-accent-gold shadow-sm border border-brand-dark/20">
                      <SafeIcon icon={FiVideo} className="w-6 h-6" />
                    </div>
                    <div>
                      <p className="text-[10px] font-black uppercase text-text-muted tracking-widest">Platform</p>
                      <p className="text-sm font-bold text-accent-navy">OneFinalLegacy Private Lobby</p>
                    </div>
                  </div>
                </div>

                <button 
                  onClick={handleJoin}
                  disabled={isJoining}
                  className="w-full btn-primary py-5 text-lg flex items-center justify-center gap-3 shadow-xl shadow-accent-navy/10 group overflow-hidden relative"
                >
                  {isJoining ? (
                    <div className="w-6 h-6 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                  ) : (
                    <>Confirm One-Click Joining <SafeIcon icon={FiCheck} className="group-hover:scale-125 transition-transform" /></>
                  )}
                </button>
              </motion.div>
            ) : (
              <motion.div key="success" initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} className="py-12 text-center">
                <div className="w-24 h-24 bg-green-500 text-white rounded-full flex items-center justify-center mx-auto mb-10 shadow-2xl shadow-green-200">
                  <SafeIcon icon={FiCheck} className="w-12 h-12" />
                </div>
                <h4 className="text-4xl font-serif text-accent-navy mb-4">You're Enrolled</h4>
                <p className="text-text-muted font-light max-w-sm mx-auto mb-10 leading-relaxed">
                  The session link has been sent to your registered email. We look forward to seeing you there.
                </p>
                <div className="flex items-center justify-center gap-2 text-[10px] font-black uppercase tracking-[0.2em] text-accent-gold">
                  <SafeIcon icon={FiShield} /> Secure Connection Guaranteed
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </motion.div>
    </div>
  );
};

export default JoinWorkshopModal;